import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "./header";
import Menu from "./menu";
import EnglishCasinoHeader from "./english_casino_header";
import GamesService from "../services/casinoGamesService";
import {
  staticContentsImagePath as BASE_IMAGE_PATH,
  OPERATOR_ID,
} from "../configs/const";
import "../css/casino/index.css";
import "../css/casino/style.css";
import "../css/casino/responsive.css";
import CasinoCurrencyModal from "./sub_components/casinoCurrencyModal";
import { casinoCurrencyList } from "../configs/casinoCurrencyList";
import * as authUtil from "../util/auth.util";
import { SHOWSPORTSBATTLECONFIG } from "../configs/gmConfigs";
let oid = OPERATOR_ID.toLowerCase();
class SportsBattle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null,
      operator: OPERATOR_ID,
      loader: true,
    };
  }

  componentDidMount() {
    const self = this;
    let accData = JSON.parse(localStorage.getItem("accountData"));
    if ((!!accData && Object.keys(accData).length > 0)) {
      const operator = this.state.operator
      setTimeout(() => {
        let token = JSON.parse(localStorage.getItem('userAuthDetail'))
        let rl = token?.role
        token = token.token
        if (!!operator && !!token && rl !== 'DemoClient') {
          window.localStorage.setItem("operator", operator);
          window.localStorage.setItem("token", token);
          let gameType = "ALL"
          debugger
          self.setState({ "operator": operator }, () => {
            window.setTimeout(function () {
              debugger
              self.loadGames();
            }, 100);
          });
        }
      }, 100)
    }
  }
  loadGames = async () => {
    const self = this;
    const operator = this.state.operator
    let token = JSON.parse(localStorage.getItem('userAuthDetail'))
    let rl = token?.role
    token = token.token
    if (!!operator && !!token && rl !== 'DemoClient') {
      window.setTimeout(function () {
        debugger
        self.getLaunchUrl();
      }.bind(this), 1500)
    }
  }

  getLaunchUrl() {
    let self = this
    const eventId = this.props.eventId;
    debugger
    GamesService.getSportBattleUrl(eventId).then((res) => {
      console.log('res', res);
      let clrs = !!SHOWSPORTSBATTLECONFIG["COLOR"] ? Object.values(SHOWSPORTSBATTLECONFIG["COLOR"]) : [];
      clrs = !!clrs ? clrs.join("|") : "";
      let durl = !!res?.data?.url ? res?.data?.url : res?.url;
      // self.setState({ url: `${res?.data?.url}&clrs=${clrs}`, loader: false });
      self.setState({ url: `${durl}&clrs=${clrs}`, loader: false });
    }).catch((e) => {
      console.log('e', e);
      self.setState({ url: ``, loader: false });
    });
  }

  render() {
    let accData = JSON.parse(localStorage.getItem("accountData"));
    const profData = JSON.parse(localStorage.getItem("profData"));
    return (
      <>
        <>
          {!!this.props.eventId ?
            <>
              {this.state.loader ?
                <>
                  <div className="row">
                    <div className="col-12">
                      <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                        <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                      </div>
                    </div>
                  </div>
                </>
                :
                <div className="">
                  <section>
                    {!!this.state.url &&
                      <iframe title={"Sports Battle"} key={"iframe"} style={{ width: "100%", height: "100vh", border: "0px", overflow: "hidden" }} src={this.state.url} ></iframe>
                    }
                  </section>
                </div>

              }
            </>
            :
            <body className="radheexch">
              <Header
                notify={this.props.notify}
                subscribe={(type, id) => {
                  this.props.subscribe(type, id);
                }}
                subscriptions={this.props.subscriptions}
                history={this.props.history}
                socket={this.props.socket}
              />
              <div
                className={`full-wrap mar-top100 footerpd ${!!accData && Object.keys(accData).length > 0
                  ? ""
                  : "mar-top100-login mar-bottom0"
                  }`}
              >
                <Menu
                  history={this.props.history}
                  subscribe={(type, id) => {
                    this.props.subscribe(type, id);
                  }}
                  subscriptions={this.props.subscriptions}
                />
                {this.state.loader ?
                  <>
                    <div className="row">
                      <div className="col-12">
                        <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                          <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                        </div>
                      </div>
                    </div>
                  </>
                  :
                  <>
                    <div className="col-center1 markets">
                      <section>
                        {!!this.state.url &&
                          <iframe title={"Sports Battle"} key={"iframe"} style={{ width: "100%", height: "100vh", border: "0px", overflow: "hidden" }} src={this.state.url} ></iframe>
                        }
                      </section>
                    </div>
                  </>
                }
              </div>
            </body>
          }
        </>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(SportsBattle);
